import * as React from 'react';
import get from 'lodash/get';
import isNumber from 'lodash/isnumber';

export function withHideIfPropValueNotInVisibleForValues<P>(valuePropName: string) {
  return (
    WrappedComponent: React.ComponentClass<P> | React.SFC<P>
  ): React.ComponentClass<P> => {
    return class extends React.Component<P & { visibleForValues: number[] }> {
      
      public render() {
        const { visibleForValues } = this.props;

        const value = get(this.props, valuePropName);

        const isVisible = !visibleForValues || !isNumber(value) ||
          (value && String(visibleForValues).split(',').findIndex(ct => Number(ct) === value) > -1);

        return isVisible ? 
          <WrappedComponent {...this.props} /> 
          : null;
      }
    };
  };
}
